export const invite = {
  fuwutiaokuan: '《Terms of Service》',
  yinsizhengce: '《Privacy Policy》',
  fzcg: 'Copied successfully',
  yqhy: "invite friends",
  fxlj: "share link",
  register_now: 'Register Now',
  phone: 'Phone',
  email: 'Email',
  placehold_phone: 'Please enter your phone number',
  placehold_email: 'Please enter your email',
  placehold_code: 'Invitation Code',
  argee: 'I have read and agree',
  agreement: '《BiKing User Agreement》',
  register: 'Register',
  phone_code: 'SMS verification code',
  email_code: 'Email verification code',
  code_to_phone: 'The verification code has been sent to your phone as a text message',
  code_to_email: 'The verification code has been sent to your email address in the form of an email',
  has_sent: 'The verification code has been sent to：',
  resend: 'Resend',
  send_code: 'Send verification code',
  unable_code: 'Unable to receive verification code?',
  set_pwd: 'Set password',
  placehold_pwd: 'Please enter your password',
  submit: 'Submit',
  error_phone: 'Please enter the correct phone number',
  error_email: 'The email format is incorrect, please re-enter',
  error_checked: 'Please confirm to check the agreement first',
  text: 'Password format error, password must be between 8 and 32 bits, including both uppercase and lowercase letters and numbers.',
  validate: 'Please complete the verification',
  register_success: 'Registration successful!',
  welcome: 'Biking welcomes you',
  start_trade: 'Recharge cryptocurrency and start trading',
  safe: 'Multiple recharge methods for secure and convenient cryptocurrency transactions',
  pay_type: 'Buying and selling cryptocurrency through bank cards or other payment methods',
  right_now_download: 'Go to download now',
  right_download: 'Go to download',
  Email_Phone:'Email/Phone,Please center',
  'Please_enter_correct_phone_number':'Please enter correct phone number',
  'Referral_code':'Please enter referral code',
  'I_have_read_and_agree':'I have read and agree',
  'BiKing_User_Agreement':'《BiKing User Agreement》',
  'Please_enter_password':'Please enter password',
  'Email_verification_code':'Email verification code',
  'SMS_code':'SMS Code',
  'Incorrect_email_format_please_reenter':'Incorrect email format, please re-enter',
  'Please_read_and_agree_User_Agreement':'Please read and agree User Agreement',
  'Sent_code_to':'Sent code to'
}


// WEBPACK FOOTER //
// ./src/i18n/lang/invite/en.js